<div *ngIf="showProgressBar">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div align="center" class="title">
  <h3>PowerSupply #{{supplyNumber}} Information</h3>
  <b>Supply Name: </b>{{supplyName}} &nbsp;
  &nbsp;
  <b>Location: </b> {{sysContact}}
  <br>
  <b>Location Information: </b> {{sysLocation}} &nbsp;
</div>
<br>
<mat-dialog-content class="mat-typography" align="center">
  <div>
    <form id="supplyFormGroup" [formGroup]="supplyFormGroup">
      <mat-form-field class="mat-form-field-infix-class">
        <mat-select placeholder="Power Supply #{{supplyNumber}} Model" formControlName="powerSupplyModel">
          <mat-option *ngFor="let powerSupplyModel of powerSupplyModels" [value]="powerSupplyModel">
            {{powerSupplyModel}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="supplyFormGroup.get('powerSupplyModel').errors?.required">
          Power Supply #{{supplyNumber}} Model is <strong>required !!</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <mat-select placeholder="AC Input Voltage Rating" (ngModelChange)="changePSAlertProfiles()" formControlName="acInputVoltageRating">
          <mat-option *ngFor="let acInputVoltageRating of acInputVoltageRatings" [value]="acInputVoltageRating">
            {{acInputVoltageRating}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="supplyFormGroup.get('acInputVoltageRating').errors?.required">
          AC Input Voltage Rating is <strong>required !!</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <mat-select placeholder="AC Output Voltage Rating" (ngModelChange)="changePSAlertProfiles()" formControlName="acOutputVoltageRating">
          <mat-option *ngFor="let acOutputVoltageRating of acOutputVoltageRatings" [value]="acOutputVoltageRating">
            {{acOutputVoltageRating}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="supplyFormGroup.get('acOutputVoltageRating').errors?.required">
          AC Output Voltage Rating is <strong>required !!</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <mat-select placeholder="Current Amp Rating" (ngModelChange)="changePSAlertProfiles()" formControlName="currentAmp">
          <mat-option *ngFor="let ampRating of ampRatings" [value]="ampRating">
            {{ampRating}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="supplyFormGroup.get('currentAmp').errors?.required">
          Current Amp Rating is <strong>required !!</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput (keydown.space)="$event.preventDefault()" placeholder="Power Supply Alert Profile"
            [value]=powerSupplyAlertProfile formControlName="powerSupplyAlertProfile">
        <mat-error *ngIf="supplyFormGroup.get('powerSupplyAlertProfile').errors?.required">
          Alert Profile is <strong>required</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput (keydown.space)="$event.preventDefault()" placeholder="Serial Number"
          formControlName="serialNumber">
      </mat-form-field>

      <mat-form-field class="mat-form-field-infix-class">
        <input matInput (keydown.space)="$event.preventDefault()" placeholder="EGIS Number"
          formControlName="egisNumber">
      </mat-form-field>

      <mat-form-field class="mat-form-field-infix-class">
        <input matInput (keydown.space)="$event.preventDefault()" placeholder="Global Identifier"
          formControlName="globalId">
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-button cdkFocusInitial [disabled]="supplyFormGroup.invalid" (click)="saveSupplyChanges()">Save Supply
    #{{supplyNumber}} Changes</button>
</mat-dialog-actions>
